<template lang="html">
  <div class="container">

    <div class="header">
      <!-- <div class="top">
        <p>业务</p>
        <p>制作</p>
        <p class="yes">阿米巴</p>
      </div> -->

      <p class="select">
        {{ time[filterdata.timeId] == '本月' ? `${year}/${month}` : time[filterdata.timeId] }},{{contrast[filterdata.contrastId]}}{{filterdata.contrastId == 1 ? '' : department[filterdata.departmentId] == undefined ? '' :  `,${department[filterdata.departmentId]}` }}
        <!-- <img src="../assets/img/avatar.jpg" alt="" @click="filter"> -->
        <i class="icon iconfont icon-shaixuan" @click="filter"></i>
      </p>

    </div>



    <div class="percent" v-if="filterdata.contrastId == 0">
      <ul>
        <!-- <div class="tips" v-if="projectData.length == 0">暂无数据</div> -->
        <nodata  v-if="projectData.length == 0" ></nodata>
        <li v-for="item in projectData" @click="toDetail(item)">
          <h2>
            {{item.p_name}}
            <span class="spantxt">{{item.complete == null ? '0' : item.complete}}%</span>
          </h2>
          <p class="txtleft">
            <span class="small">¥</span>
            {{(item.money/10000).toFixed(2)}}
            <span class="small">(万)</span>
            <br>
            <span class="pre">项目金额</span>

          </p>
          <p class="txtright">
            <span class="small">¥</span>
            {{item.all_value}}
            <span class="small">(万)</span>
            <br>
            <span class="pre">项目总产值</span>
          </p>
        </li>


      </ul>

    </div>

    <div class="percent" v-if="filterdata.contrastId == 1">
      <ul>
        <nodata  v-if="departmentData.length == 0" ></nodata>
        <li v-for="item in departmentData">
          <h2>
            {{department[item.group_id]}}
          </h2>

          <p class="txtleft">
            <span class="small">¥</span>
            {{(item.all_value/10000).toFixed(2)}}
            <span class="small">(万)</span>
            <br>
            <span class="pre">总产值</span>

          </p>
          <p class="txtright">
            {{item.all_cost}}h
            <br>
            <span class="pre">总耗时(h)</span>
          </p>
        </li>

      </ul>

    </div>

    <div class="percent" :class="{'amiba': filterdata.contrastId == 2}" v-if="filterdata.contrastId == 2">
      <ul>
        <nodata  v-if="amoebaData.length == 0" ></nodata>
        <li v-for="item in amoebaData">
          <h2>
            阿米巴小组名称
          </h2>
          <p class="group">组长&nbsp;{{item.leader}}</p>
          <p class="txtleft">
            <span class="small">¥</span>
            {{(item.all_value/10000).toFixed(2)}}
            <span class="small">(万)</span>
            <br>
            <span class="pre">总产值</span>

          </p>
          <p class="txtright">
            {{item.all_cost}}h
            <br>
            <span class="pre">总耗时(h)</span>
          </p>
        </li>

      </ul>

    </div>


    <div  class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <div  class="selbox" v-if="isFilter"><p >筛选</p>
      <p  class="content">
        对比类型
      </p>
      <ul  class="listtime">
        <li  :class="{'true':isFilterdata.contrastId == index,'zzbsize': index == 1, 'ambsize': index == 2}" v-for="(item,index) in contrast" @click="filterConstrast(index)">{{item}}</li>
      </ul>


      <p  class="content">
        时间
      </p>
      <ul  class="listtime">
        <li  :class="{'true':isFilterdata.timeId == index}" v-for="(item,index) in time" @click="filterTime(index)">{{item}}</li>
      </ul>


      <p  class="content" v-if="isFilterdata.contrastId != 1">
        制作部
      </p>
      <ul  class="listtime" v-if="isFilterdata.contrastId != 1">
        <li style="font-size:12px;width:2.8rem;margin-left:0.2rem;margin-right:0.1rem" :class="{'true':isFilterdata.departmentId == index, 'next': index == 25 || index == 28}" v-for="(item,index) in department" @click="filterDepart(index)">{{item}}</li>
      </ul>



      <p  class="content" v-if="isFilterdata.contrastId != 1 && isFilterdata.contrastId != 2">
        项目状态
      </p>
      <ul  class="listtime" v-if="isFilterdata.contrastId != 1 && isFilterdata.contrastId != 2">
        <li :class="{'true':isFilterdata.completeId == index}" v-for="(item,index) in complete" @click="filterComplete(index)">{{item}}</li>
      </ul>




      <p  class="btnyes" @click="confirmFilter">确定</p>
    </div>

  </div>
</template>

<script>
import nodata from './public/nodata'
export default {
  components:{
    nodata,
  },
  data () {
    return {
      year:null,
      month:null,
      isFilter:false,
      filterdata:{
        timeId:1,
        contrastId:0,
        departmentId:0,
        completeId:1,
      },
      isFilterdata:{
        timeId:1,
        contrastId:0,
        departmentId:0,
        completeId:1,
      },

      contrast:{0:'项目对比',1:'制作部对比',2:'小组对比'},
      time:{1:'本周',2:'本月'},
      // department:['全部','制作一部','制作二部','制作三部','制作四部','制作五部'],
      department:{},
      complete:{1:'开发中',2:'已完成'},

      projectData:[],
      departmentData:[],
      amoebaData:[],
    }
  },
  methods:{
    toDetail (item) {
      this.$router.push({name:'projectclick',params:{data:item,department:this.department}})
    },
    filter () {
      this.isFilter = true
      this.$emit('inFilter')
    },
    filterConstrast (id) {
      this.isFilterdata.contrastId = id
    },
    filterTime (id) {
      this.isFilterdata.timeId = id
    },
    filterDepart (id) {
      this.isFilterdata.departmentId = id
    },
    filterComplete (id) {
      this.isFilterdata.completeId = id
    },
    filterDate (type, date, group, status) {
      let data = null
      if ( type == 1 ) {
        data = {
          date,
          group,
          status
        }
      } else if ( type == 3 ) {
        data = {
          date,
          group,
        }
      }
      return data

    },
    cancel () {
      this.isFilter = false
      this.$emit('noFilter')
    },
    confirmFilter () {
      this.filterdata = {
        timeId: this.isFilterdata.timeId,
        contrastId: this.isFilterdata.contrastId,
        departmentId: this.isFilterdata.departmentId,
        completeId: this.isFilterdata.completeId,
      }
      if ( this.filterdata.contrastId == 0 ) {
        let data  = this.filterDate( 1 ,this.filterdata.timeId,this.filterdata.departmentId,this.filterdata.completeId)
        this.$http.getProjectContrast(data).then( res => {
          this.projectData = res.data.data
        })
      } else if ( this.filterdata.contrastId == 1 ) {
        this.$http.getMakeContrast(this.filterdata.timeId).then( res => {
          this.departmentData = res.data.amoeba
        })
      } else {
        let data  = this.filterDate( 3 ,this.filterdata.timeId,this.filterdata.departmentId)
        this.$http.getAmoebaContrast(data).then( res => {
          this.amoebaData = res.data.amoeba

        })
      }
      this.isFilter = false
      this.$emit('noFilter')

    },


  },
  created () {
    let data = {date:1,group:0,status:1}
    this.$notice.loading()
    var d = new Date()
    var y = d.getFullYear()
    var m = d.getMonth() + 1
    m = m < 10 ? "0" + m : m
    this.year = y
    this.month = m
    this.$http.getProjectContrast(data).then( res => {

      // let key = 0
      // res.data.group_data.key = '全部'
      let obj = res.data.group_data
      let department = { 0:'全部'}
      for(var key in obj){
        department[key] = obj[key]
      }
      this.department = department
      this.projectData = res.data.data
      this.$notice.loading(false)
    })
  },
}
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #fafafa;
  }
  .header{
    width: 100%;
    background: #f5f5f5;
    padding-top: 0.15625rem;
    margin-bottom: 0.21875rem;
  }
  /*.header img{
    width: 0.6875rem;
    height: 0.6875rem;
    position: absolute;
    right: 0.5rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }*/
  .header .icon{
    font-size: 0.5rem;
    position: absolute;
    right: 0.5rem;
    top: 0;
    margin: auto;
  }
  .select{
    width: 100%;
    color: #fff;
    height: 1.1875rem;
    background: #5483D2;
    font-size: 0.4375rem;
    line-height: 1.1875rem;
    padding-left: 0.34375rem;
    margin-bottom: 0.1875rem;
    position: relative;
    clear: both;
  }
  .yes{
    background: #5483D2;
    color: #fff;
  }
  .top{
    width: 85%;
    border: 1px solid #5483D2;
    color: #737171;
    font-size: 0.4375rem;
    margin: auto;
    border-radius: 0.09375rem;
    margin-bottom: 0.25rem;
    height: 0.875rem;
  }
  .top p{
    float: left;
    width: 33.3%;
    text-align: center;
    border-right: 1px solid #5483D2;
    padding: 0.125rem;
    height: 100%;
  }
  .top p:last-child{
    border:0;
  }

  .percent{
    color: #000;
    position: relative;
    width: 100%;
    background: #fff;
    margin-bottom: 0.1875rem;
  }
  .percent ul{
    width: 100%;
    margin: auto;
    background: #fafafa;
    height: 100%;
  }
  .percent ul li{
    position: relative;
    width: 95%;
    margin: auto;
    background: #fff;
    margin-bottom: 0.15625rem;
    border-radius: 0.09375rem;
    height: 2.5625rem;
  }
  .percent.amiba ul li{
    height: 3.0625rem;
  }
  .percent ul li h2{
    color: #333333;
    font-size: 0.4375rem;
    font-weight: 500;
    margin-top: 0.15625rem;
    font-family: PingFangSC-Regular;
    border-left: 0.09375rem solid #5483D2;
    padding-left: 0.5rem;
    height: 0.9375rem;
    line-height: 1.09375rem;
    margin-bottom: 0.09375rem;
    border-top-left-radius: 0.09375rem;
  }
  .group {
    color: #333;
    font-size: 0.4375rem;
    padding-left: 0.59375rem;
    margin-top: -0.125rem;
    margin-bottom: 0.0625rem;
  }
  .spantxt{
    font-size: 0.34375rem;
    padding-left:0.375rem;
    margin-top: 0.25rem;
    font-family:PingFangSC-Regular;
    color: #5483D2;
    position: absolute;
    right: 0.40625rem;
  }

  .txtleft{
    width: 49%;
    float: left;
    text-align: center;
    color: #5483D2;
    font-size:0.5rem;
    font-family:PingFangSC-Medium;
  }
  .txtright{
    width: 49%;
    float: right;
    text-align: center;
    color: #5483D2;
    font-size:0.5rem;
    font-family:PingFangSC-Medium;
  }
  .pre{
    font-size: 0.375rem;
    color: #333;
  }

  .small{
    font-size: 0.34375rem;
    display: inline-block;
    color: #5483D2;
  }

  .zhezhao{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 9;
    width: 100%;
    height: 100%;

  }

  .selbox{
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 7.0625rem;
    z-index: 99;
    background: #fff;
    /*transition: */
  }
  .selbox p:first-child {
    color: #999999;
    background: #F2F2F2;
    font-size: 0.375rem;
    height: 0.9375rem;
    line-height: 0.9375rem;
    padding-left: 0.46875rem;
  }
  .content{
    background: #fff;
    color: #333333;
    font-size: 0.4375rem;
    padding-left: 0.34375rem;
    padding-top: 0.1875rem;
    /* margin-top: 0.4375rem; */
  }
  .listtime{
    margin-top: 0.1875rem;
  }
  .listtime li{
     width: 2.0625rem;
     text-align: center;
     height: 0.8rem;
     line-height: 0.8rem;
     border-radius: 0.125rem;
     background: #F1F1F1;
     color: #333333;
     display: inline-block;
     font-size: 0.375rem;
    margin-right: 0.09375rem;
   }
  .true{
    color: #5483D2!important;
    background: #C9DDFD!important;
  }
  .listtime li:first-child {
    margin-left: 0.3125rem;
    margin-bottom: 0.15625rem;
  }
  .ambsize{
    display:block;
    margin-left: 0.3125rem;
    width: 2.0625rem!important;
  }
  .zzbsize{
    width: 2.4375rem!important;
  }
  .next{
    margin-left: 0.3125rem;
    margin-bottom: 0.15625rem;
  }
  .btnyes{
    height: 1.25rem;
    line-height: 1.25rem;
    background: #5483D2;
    position: absolute;
    width: 100%;
    bottom: 0;
    text-align: center;
    color: #fff;
    font-size: 0.4375rem;
  }
  .tips{
    background-color: #fff;
    /*height: 0.9375rem;*/
    font-size: 0.375rem;
    text-align: center;
    padding-top: 0.9375rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Project.vue